import axios from "axios";

export const api = new axios.create({
  baseURL: "https://zq3277so4f.execute-api.us-east-1.amazonaws.com/Production",
});

export const apiDesenv = new axios.create({
  baseURL: "https://zq3277so4f.execute-api.us-east-1.amazonaws.com/Development",
});
